// src/components/ExistencePlexo.js — VERSÃO FINAL 100%
import React, { useState, useEffect } from 'react';
import { connectWallet } from '../utils/web3.js';
import { submitProofX } from '../utils/submitProofX.js';
import AdPlaceholder from './AdPlaceholder';
import ResultCelebration from './ResultCelebration';

const ExistencePlexo = () => {
  const [message, setMessage] = useState('aquiAgora');
  const [tweet, setTweet] = useState(false);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [wallet, setWallet] = useState(null);

  // === RECUPERA WALLET PERSISTENTE ===
  useEffect(() => {
    const saved = localStorage.getItem('walletInfo');
    if (saved) setWallet(JSON.parse(saved));
  }, []);

  const handleConnect = async () => {
    setLoading(true);
    try {
      const res = await connectWallet();
      setWallet(res);
      localStorage.setItem('walletInfo', JSON.stringify(res));
    } catch {
      alert('Erro ao conectar MetaMask');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    if (!wallet?.address) return alert('Conecte a carteira');
    if (message.trim().length === 0) return alert('Escreva uma mensagem');
    if (message.length > 280) return alert('Máximo 280 caracteres');

    setLoading(true);
    try {
      const data = await submitProofX(message);
      setResult(data);

      const token = localStorage.getItem('token');
      if (token) {
        await fetch('https://plexo-natural-api.onrender.com/api/save-existence', {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            message,
            txHash_X: data.tx.hash,
            proofHash: data.proofHash,
            timestamp: new Date().toISOString(),
            tweeted: tweet
          })
        });
      }
      if (tweet) {
        handleTweet(data);
      }
    } catch (err) {
      alert(err.message || 'Erro ao registrar prova');
    } finally {
      setLoading(false);
    }
  };

  const handleTweet = (customData = null) => {
    const finalData = customData || result;
    if (!finalData) return;

    const text = encodeURIComponent(
      `Proof of Existence registered at @PlexoNatural!\n\n"${message}"\n\nTx: ${finalData.tx.hash}\n\nhttps://polygonscan.com/tx/${finalData.tx.hash}\n\n#Web3 #RUA #ProofOfExistence https://network.plexonatural.com`
    );

    window.open(`https://twitter.com/intent/tweet?text=${text}`, '_blank');
  };

  return (
    <div className="min-h-screen bg-white pt-16">
      {/* Container principal com sidebars para anúncios */}
      <div className="max-w-7xl mx-auto px-4 py-8 flex gap-6">
        {/* SIDEBAR ESQUERDA - ANÚNCIO (apenas desktop) */}
        <aside className="hidden lg:block flex-shrink-0">
          <AdPlaceholder position="sidebar" />
        </aside>

        {/* CONTEÚDO PRINCIPAL */}
        <main className="flex-1 max-w-md mx-auto">
          <div className="bg-white border-2 border-violet-200 rounded-xl p-6 shadow-md">
            <h2 className="text-3xl font-bold text-center mb-2 text-black">Prova de Existência</h2>
            <p className="text-sm text-gray-600 text-center mb-8">Registre na blockchain</p>

            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              maxLength={280}
              className="w-full p-4 rounded-lg bg-gray-50 border border-gray-300 text-black placeholder-gray-400 mb-3 resize-none focus:outline-none focus:ring-2 focus:ring-violet-500"
              rows={4}
              placeholder="aquiAgora"
            />
            <p className="text-xs text-right mb-6 text-gray-500">{message.length}/280</p>

            {/* ✅ PRESERVADO: Checkbox tweet */}
            <label className="flex items-center gap-3 mb-8 cursor-pointer select-none">
              <input type="checkbox" checked={tweet} onChange={(e) => setTweet(e.target.checked)} className="sr-only" />
              <div className={`w-7 h-7 rounded border-2 transition-all ${tweet ? 'bg-violet-600 border-violet-600' : 'border-gray-400'}`}>
                {tweet && (
                  <svg className="w-5 h-5 text-white absolute top-1 left-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                  </svg>
                )}
              </div>
              <span className="text-sm text-black">Publish to X</span>
            </label>

            {/* ✅ PRESERVADO: Botão MetaMask */}
            {!wallet ? (
              <button
                onClick={handleConnect}
                disabled={loading}
                className="w-full py-4 bg-gradient-to-r from-violet-600 to-green-500 rounded-lg font-bold text-lg hover:from-violet-700 hover:to-green-600 transition mb-4 text-white"
              >
                {loading ? 'Conectando...' : 'Conectar MetaMask'}
              </button>
            ) : (
              <p className="text-xs mb-4 text-gray-600 truncate">Carteira: {wallet.address}</p>
            )}

            <button
              onClick={handleSubmit}
              disabled={loading || !wallet}
              className="w-full py-5 bg-gradient-to-r from-violet-600 to-green-500 rounded-lg font-bold text-xl disabled:opacity-50 hover:from-violet-700 hover:to-green-600 transition-all shadow-md text-white"
            >
              {loading ? 'Registrando...' : 'Provar Existência'}
            </button>

            {/* ✅ Hidden result - shown in celebration modal instead */}

            {/* ✅ PRESERVADO: Créditos */}
            <div className="mt-12 text-center text-xs opacity-60 text-gray-600">
              Proof of eXistence is one more proof of X AI services assistance.<br />
              Tesla, SpaceX and yours can also be one... Just prove.
            </div>
          </div>
        </main>

        {/* SIDEBAR DIREITA - ANÚNCIO (apenas desktop) */}
        <aside className="hidden lg:block flex-shrink-0">
          <AdPlaceholder position="sidebar" />
        </aside>
      </div>

      {/* RODAPÉ - BANNER DE ANÚNCIO */}
      <footer className="max-w-7xl mx-auto px-4 py-6 mt-8">
        <div className="flex justify-center">
          <AdPlaceholder position="footer" />
        </div>
      </footer>

      {/* 🎉 Celebration Modal */}
      {result && (
        <ResultCelebration
          result={result}
          message={message}
          onClose={() => setResult(null)}
          onTweet={() => {
            handleTweet(result);
            setResult(null);
          }}
        />
      )}
    </div>
  );
};

export default ExistencePlexo;
